import { useState } from "react";
import { ShareProgress } from "@/components/progress/ShareProgress";
import type { Routine } from "instantdb/types";
import { RoutineColors } from "@/utilities/routineColors";

// Mock routine data with streak-like completion patterns
const MOCK_ROUTINES: any[] = [
  {
    id: "1",
    title: "Morning Meditation",
    symbol: "🧘",
    color: RoutineColors[4].value,
    dailyRoutine: false,
    selectedDays: [
      { day: "monday", datetime: "08:00:00.000Z" },
      { day: "tuesday", datetime: "08:00:00.000Z" },
      { day: "wednesday", datetime: "08:00:00.000Z" },
      { day: "thursday", datetime: "08:00:00.000Z" },
      { day: "friday", datetime: "08:00:00.000Z" },
      { day: "saturday", datetime: "08:00:00.000Z" },
      { day: "sunday", datetime: "08:00:00.000Z" },
    ],
    daysCompleted: [
      {
        id: "1-1",
        date: "2024-12-01T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-2",
        date: "2024-12-02T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-3",
        date: "2024-12-03T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-4",
        date: "2024-12-04T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-5",
        date: "2024-12-05T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-6",
        date: "2024-12-06T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-7",
        date: "2024-12-07T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-8",
        date: "2024-12-08T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-9",
        date: "2024-12-09T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-10",
        date: "2024-12-10T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-11",
        date: "2024-12-11T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-12",
        date: "2024-12-12T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-13",
        date: "2024-12-13T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "1-14",
        date: "2024-12-14T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    ],
    steps: [],
    createdAt: Date.now(),
    updatedAt: Date.now(),
    order: 0,
    healthAreaSlug: "mental-health",
  },
  {
    id: "2",
    title: "Drink Water",
    symbol: "💧",
    color: RoutineColors[8].value,
    dailyRoutine: true,
    selectedDays: [],
    daysCompleted: [
      {
        id: "2-1",
        date: "2024-12-01T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-2",
        date: "2024-12-02T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-3",
        date: "2024-12-03T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-4",
        date: "2024-12-04T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-5",
        date: "2024-12-05T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-6",
        date: "2024-12-06T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-7",
        date: "2024-12-07T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      // Missing day 8 to show a broken streak
      {
        id: "2-9",
        date: "2024-12-09T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-10",
        date: "2024-12-10T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-11",
        date: "2024-12-11T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-12",
        date: "2024-12-12T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-13",
        date: "2024-12-13T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "2-14",
        date: "2024-12-14T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    ],
    steps: [],
    createdAt: Date.now(),
    updatedAt: Date.now(),
    order: 1,
    healthAreaSlug: "nutrition",
  },
  {
    id: "3",
    title: "Evening Walk",
    symbol: "🚶",
    color: RoutineColors[12].value,
    dailyRoutine: false,
    selectedDays: [
      { day: "monday", datetime: "18:00:00.000Z" },
      { day: "tuesday", datetime: "18:00:00.000Z" },
      { day: "wednesday", datetime: "18:00:00.000Z" },
      { day: "thursday", datetime: "18:00:00.000Z" },
      { day: "friday", datetime: "18:00:00.000Z" },
      { day: "saturday", datetime: "18:00:00.000Z" },
      { day: "sunday", datetime: "18:00:00.000Z" },
    ],
    daysCompleted: [
      {
        id: "3-2",
        date: "2024-12-02T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-3",
        date: "2024-12-03T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-4",
        date: "2024-12-04T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-5",
        date: "2024-12-05T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-6",
        date: "2024-12-06T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-9",
        date: "2024-12-09T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-10",
        date: "2024-12-10T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "3-11",
        date: "2024-12-11T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      // Missing day 12 (Thursday) to show a broken streak
      {
        id: "3-13",
        date: "2024-12-13T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    ],
    steps: [],
    createdAt: Date.now(),
    updatedAt: Date.now(),
    order: 2,
    healthAreaSlug: "fitness",
  },
  {
    id: "4",
    title: "Read Book",
    symbol: "📚",
    dailyRoutine: false,
    color: RoutineColors[1].value,
    selectedDays: [
      { day: "monday", datetime: "10:00:00.000Z" },
      { day: "tuesday", datetime: "10:00:00.000Z" },
      { day: "wednesday", datetime: "10:00:00.000Z" },
      { day: "thursday", datetime: "10:00:00.000Z" },
      { day: "friday", datetime: "10:00:00.000Z" },
      { day: "saturday", datetime: "10:00:00.000Z" },
      { day: "sunday", datetime: "10:00:00.000Z" },
    ],
    daysCompleted: [
      {
        id: "4-1",
        date: "2024-12-01T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      // Missing day 7 (Saturday) to show a broken streak
      {
        id: "4-8",
        date: "2024-12-08T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
      {
        id: "4-14",
        date: "2024-12-14T00:00:00.000Z",
        completed: true,
        stepsCompleted: [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    ],
    steps: [],
    createdAt: Date.now(),
    updatedAt: Date.now(),
    order: 3,
    healthAreaSlug: "mental-health",
  },
];

export function ProgressStreaksDemo() {
  return (
    <div className="w-full h-full flex justify-center items-center bg-gradient-to-l from-green-100 to-teal-100 dark:from-green-900/30 dark:to-teal-900/30 p-6">
      <ShareProgress
        routines={MOCK_ROUTINES as Routine[]}
        currentDate={new Date("2024-12-13")}
        onDateChange={() => {}} // No-op since this is just a demo
        isHomepage={true}
        hideShareButton={true}
        hideNavigation={true}
      />
    </div>
  );
}
